"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RecipePickList = exports.RecipeCategory = exports.RecipeBook = exports.Recipe = exports.BackToTop = void 0;
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.parse-int.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./pixelated.recipe.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* ========== RECIPE BOOK ========== */
class RecipeBook extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {
      recipeElems: this.generateMyElems(),
      outputElems: [],
      showOnlyCat: '',
      showOnlyRecipe: ''
    };
    this.onRecipePickListChange = this.onRecipePickListChange.bind(this);
  }
  generateMyElems() {
    const myElems = [];
    for (const catKey in this.props.recipeCategories) {
      const category = this.props.recipeCategories[catKey];
      myElems[category] = [];
      for (const recipeKey in this.props.recipeData.items) {
        const recipe = this.props.recipeData.items[recipeKey];
        const cats = recipe.properties.category;
        if (cats.includes(category)) {
          myElems[category].push(recipe);
        }
      }
    }
    return myElems;
  }
  outputMyElems() {
    const myElems = [];
    let catKey = 1;
    for (const category in this.state.recipeElems) {
      const cID = 'c' + catKey;
      myElems.push( /*#__PURE__*/_react.default.createElement(RecipeCategory, {
        key: cID,
        id: cID,
        className: "h-recipe-category",
        category: category,
        showOnly: this.state.showOnlyCat
      }));
      for (const recipeKey in this.state.recipeElems[category]) {
        const recipe = this.state.recipeElems[category][recipeKey];
        const cats = recipe.properties.category;
        const rID = cID + '-r' + (parseInt(recipeKey, 10) + 1);
        if (cats.includes(category)) {
          myElems.push( /*#__PURE__*/_react.default.createElement(Recipe, {
            key: rID,
            id: rID,
            recipeData: recipe,
            showOnly: this.state.showOnlyRecipe
          }));
        }
      }
      catKey += 1;
    }
    this.setState({
      outputElems: myElems
    });
  }
  componentDidMount() {
    this.outputMyElems();
  }
  onRecipePickListChange(optionVal) {
    let cID, rID;
    if (optionVal.includes('-')) {
      cID = optionVal.substring(0, optionVal.indexOf('-'));
      rID = optionVal;
    } else {
      cID = optionVal;
      rID = optionVal;
    }
    this.setState({
      showOnlyCat: cID,
      showOnlyRecipe: rID
    }, () => {
      this.outputMyElems();
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      id: "recipes"
    }, /*#__PURE__*/_react.default.createElement(BackToTop, null), /*#__PURE__*/_react.default.createElement(RecipePickList, {
      recipeData: this.props.recipeData,
      recipeCategories: this.props.recipeCategories,
      handleRecipePickListChange: this.onRecipePickListChange
    }), this.state.outputElems);
  }
}

/* ========== RECIPE CATEGORY ========== */
exports.RecipeBook = RecipeBook;
_defineProperty(RecipeBook, "propTypes", {
  recipeData: _propTypes.default.object.isRequired,
  recipeCategories: _propTypes.default.array.isRequired
});
class RecipeCategory extends _react.Component {
  render() {
    const isHidden = this.props.showOnly.length > 0 && !this.props.id.includes(this.props.showOnly) ? {
      display: 'none'
    } : {
      display: 'initial'
    };
    return /*#__PURE__*/_react.default.createElement("h2", {
      id: this.props.id,
      className: this.props.className,
      style: isHidden
    }, this.props.category);
  }
}

/* ========== RECIPE ========== */
exports.RecipeCategory = RecipeCategory;
_defineProperty(RecipeCategory, "propTypes", {
  id: _propTypes.default.string.isRequired,
  className: _propTypes.default.string.isRequired,
  category: _propTypes.default.string.isRequired,
  showOnly: _propTypes.default.string.isRequired
});
class Recipe extends _react.Component {
  render() {
    const recipe = this.props.recipeData.properties;
    const ingredients = recipe.ingredients.map((ingredient, iKey) => /*#__PURE__*/_react.default.createElement("li", {
      key: iKey,
      className: "p-ingredient"
    }, ingredient));
    const instructions = recipe.instructions.map((instruction, iKey) => /*#__PURE__*/_react.default.createElement("li", {
      key: iKey,
      className: "p-instruction"
    }, instruction));
    const recipeImage = recipe.photo.length > 0 ? /*#__PURE__*/_react.default.createElement("img", {
      className: "u-photo",
      src: recipe.photo,
      alt: recipe.name
    }) : null;
    const isHidden = this.props.showOnly.length > 0 && !this.props.id.includes(this.props.showOnly) ? {
      display: 'none'
    } : {
      display: 'initial'
    };
    /* event.preventDefault(); */
    return /*#__PURE__*/_react.default.createElement("article", {
      id: this.props.id,
      className: "h-recipe",
      style: isHidden
    }, /*#__PURE__*/_react.default.createElement("h3", {
      className: "p-name"
    }, /*#__PURE__*/_react.default.createElement("a", {
      name: this.props.id,
      href: "#",
      onClick: () => {
        return false;
      }
    }, recipe.name)), recipeImage, /*#__PURE__*/_react.default.createElement("p", {
      className: "p-summary"
    }, recipe.summary), /*#__PURE__*/_react.default.createElement("p", null, "\xA0"), /*#__PURE__*/_react.default.createElement("p", {
      className: "p-author"
    }, "Author: ", recipe.author), /*#__PURE__*/_react.default.createElement("p", {
      className: "p-published"
    }, "Published: ", recipe.published), /*#__PURE__*/_react.default.createElement("p", {
      className: "dt-duration"
    }, "Duration: ", recipe.duration), /*#__PURE__*/_react.default.createElement("p", {
      className: "p-yield"
    }, "Yield: ", recipe.yield), /*#__PURE__*/_react.default.createElement("h4", {
      className: "e-ingredients"
    }, "Ingredients"), /*#__PURE__*/_react.default.createElement("ul", null, ingredients), /*#__PURE__*/_react.default.createElement("h4", {
      className: "e-instructions"
    }, "Instructions"), /*#__PURE__*/_react.default.createElement("ol", null, instructions));
  }
}

/* ========== RECIPE PICK LIST ========== */
exports.Recipe = Recipe;
_defineProperty(Recipe, "propTypes", {
  recipeData: _propTypes.default.object.isRequired,
  id: _propTypes.default.string.isRequired,
  showOnly: _propTypes.default.string.isRequired
});
class RecipePickList extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {
      recipeOptions: []
    };
    this.recipeListChanged = this.recipeListChanged.bind(this);
  }
  generateMyOptions() {
    const myOpts = [];
    myOpts.push( /*#__PURE__*/_react.default.createElement("option", {
      key: "x0",
      value: ""
    }, "Choose a recipe below:"));
    for (const catKey in this.props.recipeCategories) {
      const category = this.props.recipeCategories[catKey];
      const cID = 'c' + (parseInt(catKey, 10) + 1);
      myOpts.push( /*#__PURE__*/_react.default.createElement("option", {
        key: cID,
        value: cID
      }, "=== ", category.toUpperCase(), " ==="));
      let rID = 1;
      for (const recipeKey in this.props.recipeData.items) {
        const recipe = this.props.recipeData.items[recipeKey];
        const cats = recipe.properties.category;
        if (cats.includes(category)) {
          myOpts.push( /*#__PURE__*/_react.default.createElement("option", {
            key: cID + '-r' + rID,
            value: cID + '-r' + rID
          }, recipe.properties.name));
          rID += 1;
        }
      }
    }
    this.setState({
      recipeOptions: myOpts
    });
  }
  recipeListChanged(e) {
    if (e.target.value.length > 0) {
      this.props.handleRecipePickListChange(e.target.value);
    } else {
      this.props.handleRecipePickListChange('');
    }
  }
  componentDidMount() {
    this.generateMyOptions();
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("form", null, /*#__PURE__*/_react.default.createElement("select", {
      id: "recipe-list",
      name: "recipe-list",
      onChange: this.recipeListChanged
    }, this.state.recipeOptions));
  }
}

/* ========== RECIPE BACK TO TOP ========== */
exports.RecipePickList = RecipePickList;
_defineProperty(RecipePickList, "propTypes", {
  recipeData: _propTypes.default.object.isRequired,
  recipeCategories: _propTypes.default.array.isRequired,
  handleRecipePickListChange: _propTypes.default.func.isRequired
});
class BackToTop extends _react.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "scrollToTop", () => {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      return false;
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "backToTop"
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: "#top",
      onClick: this.scrollToTop
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("img", {
      src: "images/up.jpg",
      alt: "Back To Top"
    })), /*#__PURE__*/_react.default.createElement("div", null, "Back To Top")));
  }
}

/* http://microformats.org/wiki/h-recipe */
/*
{
    "items": [
    {
      "type": [ "h-recipe" ],
      "properties": {
        "name": [ "" ],
        "summary": [ "" ],
        "author": [ "" ],
        "published": [ "" ],
        "yield": [ "" ],
        "duration": [ "" ],
        "ingredients": [
          "",
          ""
        ],
        "instructions": [
          "",
          ""
        ],
        "nutrition": [ "" ],
        "photo": [ "" ],
        "category": [
          "",
          ""
        ],
        "license": [ "http://creativecommons.org/licenses/by/2.0/" ]
      }
    }
  ]
}
*/
exports.BackToTop = BackToTop;
_defineProperty(BackToTop, "propTypes", {});